import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Repeat, ArrowRight, DollarSign, Eye } from 'lucide-react';
export function ThreeLoopEngine() {
  return <Section className="bg-black" data-id="element-331">
      <div className="glow-line w-full max-w-xs mx-auto mb-16" data-id="element-332" />
      <div className="text-center mb-16" data-id="element-333">
        <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-334">
          La verdad incómoda{' '}
          <span className="text-white/20" data-id="element-335">(y liberadora)</span>
        </h2>
        <p className="text-xl text-gray-400" data-id="element-336">
          No necesitas 100 ideas. Necesitas 3 piezas que se repiten.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 relative" data-id="element-337">
        <div className="hidden md:block absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#14b8a6]/20 to-transparent -translate-y-1/2 z-0" data-id="element-338" />

        <motion.div whileHover={{
        y: -5
      }} className="glass-card p-8 relative z-10 flex flex-col items-center text-center group hover:border-[#14b8a6]/30 transition-all duration-300" data-id="element-339">
          <div className="w-16 h-16 bg-white/[0.04] rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#14b8a6] group-hover:text-black transition-all duration-300 border border-white/[0.06]" data-id="element-340">
            <Eye size={28} data-id="element-341" />
          </div>
          <h3 className="text-xl font-bold mb-2 text-white" data-id="element-342">
            1. Contenido Prueba
          </h3>
          <p className="text-gray-400 text-sm leading-relaxed" data-id="element-343">
            Construye autoridad inmediata sin necesidad de títulos.
          </p>
        </motion.div>

        <motion.div whileHover={{
        y: -5
      }} className="glass-card p-8 relative z-10 flex flex-col items-center text-center group hover:border-[#06b6d4]/30 transition-all duration-300" data-id="element-344">
          <div className="w-16 h-16 bg-white/[0.04] rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#06b6d4] group-hover:text-black transition-all duration-300 border border-white/[0.06]" data-id="element-345">
            <ArrowRight size={28} data-id="element-346" />
          </div>
          <h3 className="text-xl font-bold mb-2 text-white" data-id="element-347">
            2. Puente a Oferta
          </h3>
          <p className="text-gray-400 text-sm leading-relaxed" data-id="element-348">
            Guía a tu audiencia exactamente hacia donde quieres.
          </p>
        </motion.div>

        <motion.div whileHover={{
        y: -5
      }} className="glass-card p-8 relative z-10 flex flex-col items-center text-center group hover:border-[#14b8a6]/30 transition-all duration-300" data-id="element-349">
          <div className="w-16 h-16 bg-white/[0.04] rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#14b8a6] group-hover:text-black transition-all duration-300 border border-white/[0.06]" data-id="element-350">
            <DollarSign size={28} data-id="element-351" />
          </div>
          <h3 className="text-xl font-bold mb-2 text-white" data-id="element-352">
            3. Activo de Conversión
          </h3>
          <p className="text-gray-400 text-sm leading-relaxed" data-id="element-353">
            El lugar donde la venta ocurre (Link / DM / Lead Magnet).
          </p>
        </motion.div>
      </div>

      <div className="mt-16 text-center luxury-border p-8 md:p-10" data-id="element-354">
        <h3 className="text-2xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-355">
          <Repeat className="text-[#14b8a6]" data-id="element-356" />
          Esto es el Motor 3-Loop
        </h3>
        <p className="text-gray-400 max-w-2xl mx-auto leading-relaxed" data-id="element-357">
          Todo esto está explicado paso a paso dentro del ebook. Con ejemplos,
          guiones y prompts listos para usar.
        </p>
      </div>
    </Section>;
}